import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createOneViewReportApi } from "./api";
import { OneViewReportReduxTypes } from "./types";

function* createOneViewReportSaga(action:any):Generator {
    try {
        const response: any = yield call(createOneViewReportApi, action.payload);
        yield put({
            type: OneViewReportReduxTypes.ONE_VIEW_REPORT_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: OneViewReportReduxTypes.ONE_VIEW_REPORT_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchCreateOneViewReport(): SagaIterator {
    yield takeEvery(OneViewReportReduxTypes.ONE_VIEW_REPORT, createOneViewReportSaga);
}

function* oneViewReportSaga(): SagaIterator {
    yield all([fork(watchCreateOneViewReport)]);
}

export default oneViewReportSaga;  